const NAME = "DIGITAL_WAREHOUSE";

export default NAME;
